import { forwardRef, type Ref, type SVGProps } from "react";
const IconInboxOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.84 17.62 24.52 5.21A2 2 0 0 0 22.68 4H9.32a2 2 0 0 0-1.84 1.21L2.16 17.62a2.1 2.1 0 0 0-.16.79V26a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-7.59a1.9 1.9 0 0 0-.16-.79M28 26H4v-7.59L9.32 6h13.36L28 18.41z" />
    <path d="M20.59 20h-9.18l-1.56-1.57A1.5 1.5 0 0 0 8.79 18H7a1 1 0 0 0 0 2h1.59l1.56 1.57a1.5 1.5 0 0 0 1.06.43h9.58a1.5 1.5 0 0 0 1.06-.43L23.41 20H25a1 1 0 0 0 0-2h-1.79a1.5 1.5 0 0 0-1.06.44zm-11.8 0" />
  </svg>
);
const ForwardRef = forwardRef(IconInboxOutlineSVG);
ForwardRef.displayName = "IconInboxOutline";
export { ForwardRef as IconInboxOutline };
